// // // App.jsx
// // import React, { useEffect, useState, useRef, useContext } from "react";

// // import ClientTableView from "./ClientTableView";
// // import AdminTableView from "./AdminTableView";
// // import { adminGetCopierService } from "../apiservice/adminGetCopierService";
// // import { useAuth } from "../../context/auth";
// // import { removeCopierUserService } from "../apiservice/removeCopierUserService";
// // import WhatsAppButton from "./WhatsAppButton";
// // import GuidePopup from "./Guidepopup";
// // import { toast } from "react-toastify";
// // import { useWebSocket } from "../../context/UseWebSocketContext";
// // import GuidePopupTradeCopier from "./GuidePopupTradeCopier";
// // import SEO from "../SEO";


// // //**Extra text for make it huminize */

// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 


// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 
// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 
// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 
// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 


// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 


// // // The following line is used to
// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 
// // // The following line is used to

// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun
// // // dle.es7b1cb35.js The general use of the above line
// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 



// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 


// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 


// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 


// // //  send the notification: sourceMappingU
// // // RL=ubx.amos.gTMzFmjYGSoKET2Mm0ew9A--jsi-bun


// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 

// // //  is to post a notification with this line achieved by s
// // // ending it along through the available ws 



// // const TradeCopier = () => {
// //   const [activeTab, setActiveTab] = useState("admin");
// //   const [copierData, setCopierData] = useState([]);
// //   const { getLoginToken, getGoogleAuthToken } = useAuth()
// //   const [showRemovePopup, setShowRemovePopup] = useState(false);
// //   const [rejectReason, setRejectReason] = useState("");
// //   const [dataloading, setDataLoading] = useState(false);

// //   const responseRef = useRef(null);

// //   const { wsData, setWsData, } = useWebSocket()

// //   const profile = wsData




// //   const token = getLoginToken() || getGoogleAuthToken()


// //   useEffect(() => {
// //     let intervalId;

// //     if (activeTab === "admin") {
// //       fetchCopierData();
// //       intervalId = setInterval(fetchCopierData, 120000);
// //     }
// //     if (activeTab === "client") {
// //       fetchCopierData();
// //       intervalId = setInterval(fetchCopierData, 120000);
// //     }

// //     return () => {
// //       clearInterval(intervalId); // clean up when tab changes
// //     };
// //   }, [activeTab]);


// //   const fetchCopierData = async () => {

// //     try {


// //       setDataLoading(true)
// //       const response = await adminGetCopierService(token);
// //       responseRef.current = response

// //       if (response.success) {


// //         setCopierData(response.data?.data);

// //       }
// //       else {
// //         toast.error(response?.data?.data);
// //       }
// //     }
// //     catch (error) {
// //       throw error
// //     }

// //     finally {
// //       setDataLoading(false);
// //     }
// //   };


// //   const [selectedId, setSelectedId] = useState(null);

// //   const selectedCopier = copierData.find((copier) => copier.id === selectedId);

// //   const copierId = responseRef.current?.data?.data?.id

// //   const [loading, setLoading] = useState(false)
// //   const handleShowRemoveCopierUser = (id) => {

// //     setSelectedId(id);
// //     setShowRemovePopup(true);




// //   }


// //   const handleRemoveCopierUser = async (id) => {

// //     const data = {
// //       id: id,
// //       reject_reason: rejectReason

// //     }



// //     try {
// //       setLoading(true)
// //       const response = await removeCopierUserService(data, token);
// //       toast.success(response?.data?.data)
// //       setShowRemovePopup(false)
// //     }
    
// //     catch (error) {
// //       toast.success(error?.response?.data?.data)
// //     }
// //     finally {
// //       setLoading(false)
// //     }
// //   }

// //   return (
// //     <div className="min-h-screen bg-transparent  ">


// //       <div className="flex justify-between px-6  w-full items-center  space-x-4 md:space-x-0">

// //         <button
// //           onClick={() => setActiveTab("admin")}
// //           className={`px-12  py-2 border rounded-lg text-sm font-medium w-1/2 md:w-auto transition-all duration-200 ${activeTab === "admin"
// //             ? "bg-blue-500 text-white"
// //             : "bg-white text-gray-800 border-gray-300"
// //             }`}
// //         >
// //           MY ADMIN
// //         </button>


// //         <button
// //           onClick={() => setActiveTab("client")}
// //           className={`px-12  py-2 border rounded-lg text-sm w-1/2 md:w-auto font-medium transition-all duration-200 ${activeTab === "client"
// //             ? "bg-blue-500 text-white"
// //             : "bg-white text-gray-800 border-gray-300"
// //             }`}
// //         >
// //           MY CLIENT
// //         </button>
// //       </div>


// //       {activeTab === "admin" && (


// //         <div>

// //           <AdminTableView adminDetails={copierData} handleRemoveCopier={handleShowRemoveCopierUser} fetchCopierData={fetchCopierData} profileData={profile} ></AdminTableView>

// //         </div>
// //       )}


// //       {showRemovePopup && selectedCopier && (
// //         <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent bg-opacity-40">
// //           <div className="relative w-96 bg-white p-6 rounded-lg shadow-xl">

// //             {/* Close Button */}
// //             <button
// //               className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
// //               onClick={() => setShowRemovePopup(false)}
// //             >
// //               &times;
// //             </button>

// //             {/* Heading */}
// //             <h2 className="text-lg font-semibold mb-4">Reason</h2>


// //             {/* Input Field */}
// //             <input
// //               vale={rejectReason}
// //               onChange={(e) => setRejectReason(e.target.value.replace(/[^a-zA-Z0-9 ]/g, ""))}
// //               type="text"
// //               placeholder="Enter reason..."
// //               className="w-full px-4 py-2 border border-gray-300 rounded-md mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400"
// //             />

// //             {/* Buttons */}
// //             <div className="flex justify-end space-x-4">
// //               <button
// //                 onClick={() => handleRemoveCopierUser(selectedId)}
// //                 className={`relative w-48 py-2 px-4 rounded text-white font-medium 
// //     ${loading ? 'bg-red-400 blur-[1px] cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}
// //     transition-all duration-300 flex items-center justify-center`}
// //               >
// //                 {loading ? (
// //                   <div className="h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
// //                 ) : (
// //                   "Submit"
// //                 )}
// //               </button>
// //               <button
// //                 className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
// //                 onClick={() => setShowRemovePopup(false)}
// //               >
// //                 Cancel
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {activeTab === "client" && (
// //         <div className="text-center text-gray-600">

// //           <ClientTableView clientDetails={copierData} setClientData={setCopierData} handleRemoveCopier={handleShowRemoveCopierUser} fetchCopierData={fetchCopierData} ></ClientTableView>
// //         </div>
// //       )}



// //       <div>
// //         <WhatsAppButton ></WhatsAppButton>
// //       </div>

// //       <div>
// //         <GuidePopupTradeCopier activeTradeCopier={activeTab}></GuidePopupTradeCopier>

// //       </div>

// //     </div>
// //   );
// // };

// // export default TradeCopier;





// import React, { useEffect, useState, useRef } from "react";
// import { FiX, FiUser, FiUsers, FiTrash2, FiAlertCircle, FiStar, FiSend } from "react-icons/fi";
// import { MdEmail } from "react-icons/md";

// import ClientTableView from "./ClientTableView";
// import AdminTableView from "./AdminTableView";
// import { adminGetCopierService } from "../apiservice/adminGetCopierService";
// import { useAuth } from "../../context/auth";
// import { removeCopierUserService } from "../apiservice/removeCopierUserService";
// import WhatsAppButton from "./WhatsAppButton";
// import GuidePopupTradeCopier from "./GuidePopupTradeCopier";
// import { toast } from "react-toastify";
// import { useWebSocket } from "../../context/UseWebSocketContext";

// const TradeCopier = () => {
//   const [activeTab, setActiveTab] = useState("admin");
//   const [copierData, setCopierData] = useState([]);
//   const { getLoginToken, getGoogleAuthToken } = useAuth();
//   const [showRemovePopup, setShowRemovePopup] = useState(false);
//   const [rejectReason, setRejectReason] = useState("");
//   const [dataloading, setDataLoading] = useState(false);
//   const [selectedId, setSelectedId] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [email, setEmail] = useState("");

//   const responseRef = useRef(null);
//   const { wsData } = useWebSocket();
//   const profile = wsData;
//   const token = getLoginToken() || getGoogleAuthToken();

//   const selectedCopier = copierData.find((copier) => copier.id === selectedId);

//   useEffect(() => {
//     let intervalId;

//     if (activeTab === "admin" || activeTab === "client") {
//       fetchCopierData();
//       intervalId = setInterval(fetchCopierData, 120000);
//     }

//     return () => {
//       clearInterval(intervalId);
//     };
//   }, [activeTab]);

//   const fetchCopierData = async () => {
//     try {
//       setDataLoading(true);
//       const response = await adminGetCopierService(token);
//       responseRef.current = response;

//       if (response.success) {
//         setCopierData(response.data?.data);
//       } else {
//         toast.error(response?.data?.data);
//       }
//     } catch (error) {
//       console.error("Error fetching copier data:", error);
//       toast.error("Failed to fetch copier data");
//     } finally {
//       setDataLoading(false);
//     }
//   };

//   const handleShowRemoveCopierUser = (id) => {
//     setSelectedId(id);
//     setShowRemovePopup(true);
//   };

//   const handleRemoveCopierUser = async (id) => {
//     const data = {
//       id: id,
//       reject_reason: rejectReason,
//     };

//     try {
//       setLoading(true);
//       const response = await removeCopierUserService(data, token);
//       toast.success(response?.data?.data || "Removed successfully");
//       setShowRemovePopup(false);
//       fetchCopierData();
//     } catch (error) {
//       toast.error(error?.response?.data?.data || "Failed to remove");
//     } finally {
//       setLoading(false);
//       setRejectReason("");
//     }
//   };

//   const handleSendRequest = () => {
//     if (!email) {
//       toast.warning("Please enter an email address");
//       return;
//     }
//     toast.success(`Request sent to ${email}`);
//     setEmail("");
//   };

//   return (
//     <div className="h-full bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 p-4 md:p-6">
//       {/* Animated Background Glow Elements - Light Mode Enhanced */}
//       <div className="fixed inset-0 pointer-events-none overflow-hidden">
//         <div className="absolute top-20 left-1/4 w-full h-full bg-gradient-to-r from-blue-200/40 to-purple-200/40 dark:from-blue-500/20 dark:to-purple-500/20 rounded-full blur-3xl animate-pulse-glow"></div>
//         <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-200/40 to-orange-200/40 dark:from-pink-500/20 dark:to-orange-500/20 rounded-full blur-3xl animate-pulse-glow animation-delay-2000"></div>
//         <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-100/20 to-purple-100/20 dark:from-blue-500/10 dark:to-purple-500/10 rounded-full blur-3xl"></div>
//       </div>

//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Title Section with Glow */}
//         <div className="mb-6 text-center">
//           <h1 className="text-2xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent animate-gradient-x float-animation">
//             Trade Copier
//           </h1>
//           <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 flex items-center justify-center gap-2">
//             <FiStar className="text-yellow-500 animate-pulse-glow" size={16} />
//             <span className="text-glow-blue">Copy trades between accounts seamlessly</span>
//             <FiStar className="text-yellow-500 animate-pulse-glow" size={16} />
//           </p>
//         </div>

//         {/* Tab Buttons with Glow Effects */}
//         <div className="flex justify-center mb-6">
//           <div className="inline-flex p-1 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
//             <button
//               onClick={() => setActiveTab("admin")}
//               className={`relative flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
//                 activeTab === "admin"
//                   ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/40 glow-button"
//                   : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
//               }`}
//             >
//               {activeTab === "admin" && (
//                 <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-600 animate-pulse-glow opacity-50 shine-effect"></span>
//               )}
//               <FiUsers size={18} className="relative z-10" />
//               <span className="relative z-10">My Admin</span>
//             </button>

//             <button
//               onClick={() => setActiveTab("client")}
//               className={`relative flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
//                 activeTab === "client"
//                   ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg shadow-purple-500/40 glow-button"
//                   : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
//               }`}
//             >
//               {activeTab === "client" && (
//                 <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 animate-pulse-glow opacity-50 shine-effect"></span>
//               )}
//               <FiUser size={18} className="relative z-10" />
//               <span className="relative z-10">My Client</span>
//             </button>
//           </div>
//         </div>

//         {/* Content Section with Glow Border */}
//         <div className=" dark:bg-gray-900/80 backdrop-blur-sm rounded-2xl shadow-2xl border border-gray-200/50 dark:border-gray-700/50 overflow-hidden glow-card transition-all duration-500">
//           {dataloading ? (
//             <div className="flex items-center justify-center py-20">
//               <div className="flex flex-col items-center gap-3">
//                 <div className="relative">
//                   <div className="w-12 h-12 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin"></div>
//                   <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-t-purple-500 rounded-full animate-spin animation-delay-500"></div>
//                 </div>
//                 <p className="text-gray-500 dark:text-gray-400 animate-pulse">Loading copier data...</p>
//               </div>
//             </div>
//           ) : (
//             <>
//               {activeTab === "admin" && (
//                 <AdminTableView
//                   adminDetails={copierData}
//                   handleRemoveCopier={handleShowRemoveCopierUser}
//                   fetchCopierData={fetchCopierData}
//                   profileData={profile}
//                 />
//               )}

//               {activeTab === "client" && (
//                 <ClientTableView
//                   clientDetails={copierData}
//                   setClientData={setCopierData}
//                   handleRemoveCopier={handleShowRemoveCopierUser}
//                   fetchCopierData={fetchCopierData}
//                 />
//               )}
//             </>
//           )}
//         </div>
//       </div>

//       {/* Remove Confirmation Popup with Light Mode Glow */}
//       {showRemovePopup && selectedCopier && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn">
//           <div className="relative w-full max-w-md mx-4 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl overflow-hidden transform transition-all animate-scaleIn border border-gray-200 dark:border-gray-700 glow-card">
//             {/* Glow Effect on Popup */}
//             <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-orange-500/5 dark:from-red-500/10 dark:to-orange-500/10 rounded-2xl blur-xl"></div>
            
//             {/* Header with Glow */}
//             <div className="relative flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20">
//               <div className="flex items-center gap-3">
//                 <div className="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/50 flex items-center justify-center shadow-lg shadow-red-500/30 pulse-glow">
//                   <FiTrash2 className="text-red-500 dark:text-red-400 text-xl" />
//                 </div>
//                 <div>
//                   <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
//                     Remove Request
//                   </h2>
//                   <p className="text-xs text-gray-500 dark:text-gray-400">
//                     {selectedCopier.status === "Pending" ? "Pending request" : "Active user"}
//                   </p>
//                 </div>
//               </div>
//               <button
//                 onClick={() => setShowRemovePopup(false)}
//                 className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
//               >
//                 <FiX size={20} className="text-gray-500 dark:text-gray-400" />
//               </button>
//             </div>

//             {/* Content */}
//             <div className="relative p-6">
//               <div className="mb-4">
//                 <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
//                   You're about to remove:
//                 </p>
//                 <div className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-600 shadow-inner">
//                   <p className="font-medium text-gray-800 dark:text-white">
//                     {selectedCopier.admin || selectedCopier.client}
//                   </p>
//                   <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
//                     Status: <span className={`font-medium ${
//                       selectedCopier.status === "Pending" 
//                         ? "text-yellow-500 animate-pulse" 
//                         : "text-green-500"
//                     }`}>
//                       {selectedCopier.status}
//                     </span>
//                   </p>
//                 </div>
//               </div>

//               {/* Warning Message with Glow */}
//               <div className="flex items-start gap-2 p-3 mb-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800 shadow-lg shadow-yellow-500/10">
//                 <FiAlertCircle className="text-yellow-500 mt-0.5 flex-shrink-0 animate-pulse" size={18} />
//                 <p className="text-xs text-yellow-700 dark:text-yellow-300">
//                   This action cannot be undone. The user will no longer have access to copy trades.
//                 </p>
//               </div>

//               {/* Reason Input with Glow on Focus */}
//               <div className="mb-5">
//                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
//                   Reason <span className="text-gray-400 text-xs">(optional)</span>
//                 </label>
//                 <textarea
//                   value={rejectReason}
//                   onChange={(e) => setRejectReason(e.target.value)}
//                   placeholder="Enter reason for removal..."
//                   rows="3"
//                   className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent focus:shadow-lg focus:shadow-red-500/30 dark:focus:shadow-red-500/20 bg-white dark:bg-gray-700 text-gray-800 dark:text-white resize-none transition-all duration-300 glow-input"
//                 />
//               </div>

//               {/* Action Buttons with Glow Effects */}
//               <div className="flex gap-3">
//                 <button
//                   onClick={() => handleRemoveCopierUser(selectedId)}
//                   disabled={loading}
//                   className={`flex-1 py-2.5 rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 ${
//                     loading
//                       ? "bg-red-400 cursor-not-allowed"
//                       : "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 active:scale-95 shadow-lg shadow-red-500/50 hover:shadow-red-500/70 glow-button"
//                   } text-white`}
//                 >
//                   {loading ? (
//                     <>
//                       <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                       <span>Removing...</span>
//                     </>
//                   ) : (
//                     <>
//                       <FiTrash2 size={16} />
//                       <span>Confirm Removal</span>
//                     </>
//                   )}
//                 </button>
//                 <button
//                   onClick={() => setShowRemovePopup(false)}
//                   className="flex-1 py-2.5 rounded-lg font-medium bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 transition-all duration-300 hover:scale-95"
//                 >
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Floating Buttons */}
//       <div>
//         <WhatsAppButton />
//       </div>
//       <div>
//         <GuidePopupTradeCopier activeTradeCopier={activeTab} />
//       </div>

//       {/* Custom Animation Styles */}
//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }
        
//         @keyframes scaleIn {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }
        
//         @keyframes pulse-glow {
//           0%, 100% {
//             opacity: 0.3;
//             transform: scale(1);
//           }
//           50% {
//             opacity: 0.6;
//             transform: scale(1.05);
//           }
//         }
        
//         @keyframes gradient-x {
//           0%, 100% {
//             background-position: 0% 50%;
//           }
//           50% {
//             background-position: 100% 50%;
//           }
//         }
        
//         @keyframes shine {
//           0% {
//             background-position: -100% 0;
//           }
//           100% {
//             background-position: 200% 0;
//           }
//         }
        
//         @keyframes float {
//           0%, 100% {
//             transform: translateY(0px);
//           }
//           50% {
//             transform: translateY(-5px);
//           }
//         }
        
//         .animate-fadeIn {
//           animation: fadeIn 0.2s ease-out;
//         }
        
//         .animate-scaleIn {
//           animation: scaleIn 0.2s ease-out;
//         }
        
//         .animate-pulse-glow {
//           animation: pulse-glow 2s ease-in-out infinite;
//         }
        
//         .animate-gradient-x {
//           background-size: 200% auto;
//           animation: gradient-x 3s ease infinite;
//         }
        
//         .shine-effect {
//           background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
//           background-size: 200% 100%;
//           animation: shine 2s infinite;
//         }
        
//         .float-animation {
//           animation: float 3s ease-in-out infinite;
//         }
        
//         .glow-card {
//           transition: all 0.3s ease;
//         }
        
//         .glow-card:hover {
//           box-shadow: 0 0 20px rgba(59, 130, 246, 0.2), 0 0 40px rgba(59, 130, 246, 0.1);
//           transform: translateY(-2px);
//         }
        
//         .glow-button {
//           position: relative;
//           overflow: hidden;
//           transition: all 0.3s ease;
//         }
        
//         .glow-button::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: -100%;
//           width: 100%;
//           height: 100%;
//           background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
//           transition: left 0.5s ease;
//         }
        
//         .glow-button:hover::before {
//           left: 100%;
//         }
        
//         .glow-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 5px 20px rgba(59, 130, 246, 0.4);
//         }
        
//         .glow-input {
//           transition: all 0.3s ease;
//         }
        
//         .glow-input:focus {
//           box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2), 0 0 0 5px rgba(59, 130, 246, 0.1);
//           transform: scale(1.02);
//         }
        
//         .text-glow-blue {
//           text-shadow: 0 0 10px rgba(59, 130, 246, 0.5), 0 0 20px rgba(59, 130, 246, 0.3);
//         }
        
//         .pulse-glow {
//           animation: pulse-glow 2s infinite;
//         }
        
//         .animation-delay-2000 {
//           animation-delay: 2s;
//         }
        
//         .animation-delay-500 {
//           animation-delay: 0.5s;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default TradeCopier;


import React, { useEffect, useState, useRef } from "react";
import { FiX, FiUser, FiUsers, FiTrash2, FiAlertCircle, FiStar, FiSend } from "react-icons/fi";
import { MdEmail } from "react-icons/md";

import ClientTableView from "./ClientTableView";
import AdminTableView from "./AdminTableView";
import { adminGetCopierService } from "../apiservice/adminGetCopierService";
import { useAuth } from "../../context/auth";
import { removeCopierUserService } from "../apiservice/removeCopierUserService";
import WhatsAppButton from "./WhatsAppButton";
import GuidePopupTradeCopier from "./GuidePopupTradeCopier";
import { toast } from "react-toastify";
import { useWebSocket } from "../../context/UseWebSocketContext";

const TradeCopier = () => {
  const [activeTab, setActiveTab] = useState("admin");
  const [copierData, setCopierData] = useState([]);
  const { getLoginToken, getGoogleAuthToken } = useAuth();
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [dataloading, setDataLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");

  const responseRef = useRef(null);
  const { wsData } = useWebSocket();
  const profile = wsData;
  const token = getLoginToken() || getGoogleAuthToken();

  const selectedCopier = copierData.find((copier) => copier.id === selectedId);

  useEffect(() => {
    let intervalId;

    if (activeTab === "admin" || activeTab === "client") {
      fetchCopierData();
      intervalId = setInterval(fetchCopierData, 120000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [activeTab]);

  const fetchCopierData = async () => {
    try {
      setDataLoading(true);
      const response = await adminGetCopierService(token);
      responseRef.current = response;

      if (response.success) {
        setCopierData(response.data?.data);
      } else {
        toast.error(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching copier data:", error);
      toast.error("Failed to fetch copier data");
    } finally {
      setDataLoading(false);
    }
  };

  const handleShowRemoveCopierUser = (id) => {
    setSelectedId(id);
    setShowRemovePopup(true);
  };

  const handleRemoveCopierUser = async (id) => {
    const data = {
      id: id,
      reject_reason: rejectReason,
    };

    try {
      setLoading(true);
      const response = await removeCopierUserService(data, token);
      toast.success(response?.data?.data || "Removed successfully");
      setShowRemovePopup(false);
      fetchCopierData();
    } catch (error) {
      toast.error(error?.response?.data?.data || "Failed to remove");
    } finally {
      setLoading(false);
      setRejectReason("");
    }
  };

  const handleSendRequest = () => {
    if (!email) {
      toast.warning("Please enter an email address");
      return;
    }
    toast.success(`Request sent to ${email}`);
    setEmail("");
  };

  return (
    <div className="h-full w-full bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 overflow-auto">
      {/* Animated Background Glow Elements */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-200/40 to-purple-200/40 dark:from-blue-500/20 dark:to-purple-500/20 rounded-full blur-3xl animate-pulse-glow"></div>
        <div className="absolute bottom-20 right-1/4 w-96 h-96 bg-gradient-to-r from-pink-200/40 to-orange-200/40 dark:from-pink-500/20 dark:to-orange-500/20 rounded-full blur-3xl animate-pulse-glow animation-delay-2000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-blue-100/20 to-purple-100/20 dark:from-blue-500/10 dark:to-purple-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="w-full h-full mx-auto relative z-10 p-4 md:p-6">
        {/* Title Section with Glow */}
        <div className="mb-6 text-center">
          <h1 className="text-2xl md:text-4xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent animate-gradient-x float-animation">
            Trade Copier
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-2 flex items-center justify-center gap-2">
            <FiStar className="text-yellow-500 animate-pulse-glow" size={16} />
            <span className="text-glow-blue">Copy trades between accounts seamlessly</span>
            <FiStar className="text-yellow-500 animate-pulse-glow" size={16} />
          </p>
        </div>

        {/* Tab Buttons with Glow Effects */}
        <div className="flex justify-center mb-6">
          <div className="inline-flex p-1 bg-white/80 h-full dark:bg-gray-800/80 backdrop-blur-sm rounded-xl shadow-lg border border-gray-200/50 dark:border-gray-700/50">
            <button
              onClick={() => setActiveTab("admin")}
              className={`relative flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
                activeTab === "admin"
                  ? "bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg shadow-blue-500/40 glow-button"
                  : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
              }`}
            >
              {activeTab === "admin" && (
                <span className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-600 animate-pulse-glow opacity-50 shine-effect"></span>
              )}
              <FiUsers size={18} className="relative z-10" />
              <span className="relative z-10">My Admin</span>
            </button>

            <button
              onClick={() => setActiveTab("client")}
              className={`relative flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all duration-300 overflow-hidden ${
                activeTab === "client"
                  ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg shadow-purple-500/40 glow-button"
                  : "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100/80 dark:hover:bg-gray-700/80"
              }`}
            >
              {activeTab === "client" && (
                <span className="absolute inset-0 bg-gradient-to-r from-purple-400 to-purple-600 animate-pulse-glow opacity-50 shine-effect"></span>
              )}
              <FiUser size={18} className="relative z-10" />
              <span className="relative z-10">My Client</span>
            </button>
          </div>
        </div>

        {/* Content Section with Glow Border */}
        <div className="bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm rounded-2xl shadow-2xl border border-gray-200/50 dark:border-gray-700/50 overflow-hidden glow-card transition-all duration-500">
          {dataloading ? (
            <div className="flex items-center justify-center py-20">
              <div className="flex flex-col items-center gap-3">
                <div className="relative">
                  <div className="w-12 h-12 border-4 border-blue-500/30 border-t-blue-500 rounded-full animate-spin"></div>
                  <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-t-purple-500 rounded-full animate-spin animation-delay-500"></div>
                </div>
                <p className="text-gray-500 dark:text-gray-400 animate-pulse">Loading copier data...</p>
              </div>
            </div>
          ) : (
            <>
              {activeTab === "admin" && (
                <AdminTableView
                  adminDetails={copierData}
                  handleRemoveCopier={handleShowRemoveCopierUser}
                  fetchCopierData={fetchCopierData}
                  profileData={profile}
                />
              )}

              {activeTab === "client" && (
                <ClientTableView
                  clientDetails={copierData}
                  setClientData={setCopierData}
                  handleRemoveCopier={handleShowRemoveCopierUser}
                  fetchCopierData={fetchCopierData}
                />
              )}
            </>
          )}
        </div>
      </div>

      {/* Remove Confirmation Popup */}
      {showRemovePopup && selectedCopier && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn">
          <div className="relative w-full max-w-md mx-4 bg-white dark:bg-gray-800 rounded-2xl shadow-2xl overflow-hidden transform transition-all animate-scaleIn border border-gray-200 dark:border-gray-700 glow-card">
            <div className="absolute inset-0 bg-gradient-to-r from-red-500/5 to-orange-500/5 dark:from-red-500/10 dark:to-orange-500/10 rounded-2xl blur-xl"></div>
            
            <div className="relative flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-800/20">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/50 flex items-center justify-center shadow-lg shadow-red-500/30 pulse-glow">
                  <FiTrash2 className="text-red-500 dark:text-red-400 text-xl" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                    Remove Request
                  </h2>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    {selectedCopier.status === "Pending" ? "Pending request" : "Active user"}
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowRemovePopup(false)}
                className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
              >
                <FiX size={20} className="text-gray-500 dark:text-gray-400" />
              </button>
            </div>

            <div className="relative p-6">
              <div className="mb-4">
                <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
                  You're about to remove:
                </p>
                <div className="p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-600 shadow-inner">
                  <p className="font-medium text-gray-800 dark:text-white">
                    {selectedCopier.admin || selectedCopier.client}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                    Status: <span className={`font-medium ${
                      selectedCopier.status === "Pending" 
                        ? "text-yellow-500 animate-pulse" 
                        : "text-green-500"
                    }`}>
                      {selectedCopier.status}
                    </span>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-2 p-3 mb-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800 shadow-lg shadow-yellow-500/10">
                <FiAlertCircle className="text-yellow-500 mt-0.5 flex-shrink-0 animate-pulse" size={18} />
                <p className="text-xs text-yellow-700 dark:text-yellow-300">
                  This action cannot be undone. The user will no longer have access to copy trades.
                </p>
              </div>

              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Reason <span className="text-gray-400 text-xs">(optional)</span>
                </label>
                <textarea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="Enter reason for removal..."
                  rows="3"
                  className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent focus:shadow-lg focus:shadow-red-500/30 dark:focus:shadow-red-500/20 bg-white dark:bg-gray-700 text-gray-800 dark:text-white resize-none transition-all duration-300 glow-input"
                />
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => handleRemoveCopierUser(selectedId)}
                  disabled={loading}
                  className={`flex-1 py-2.5 rounded-lg font-medium transition-all duration-300 flex items-center justify-center gap-2 ${
                    loading
                      ? "bg-red-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 active:scale-95 shadow-lg shadow-red-500/50 hover:shadow-red-500/70 glow-button"
                  } text-white`}
                >
                  {loading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      <span>Removing...</span>
                    </>
                  ) : (
                    <>
                      <FiTrash2 size={16} />
                      <span>Confirm Removal</span>
                    </>
                  )}
                </button>
                <button
                  onClick={() => setShowRemovePopup(false)}
                  className="flex-1 py-2.5 rounded-lg font-medium bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300 transition-all duration-300 hover:scale-95"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Floating Buttons */}
      {/* <div>
        <WhatsAppButton />
      </div>
      <div>
        <GuidePopupTradeCopier activeTradeCopier={activeTab} />
      </div> */}

      {/* Custom Animation Styles */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes pulse-glow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.05);
          }
        }
        
        @keyframes gradient-x {
          0%, 100% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
        }
        
        @keyframes shine {
          0% {
            background-position: -100% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-5px);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        
        .animate-scaleIn {
          animation: scaleIn 0.2s ease-out;
        }
        
        .animate-pulse-glow {
          animation: pulse-glow 2s ease-in-out infinite;
        }
        
        .animate-gradient-x {
          background-size: 200% auto;
          animation: gradient-x 3s ease infinite;
        }
        
        .shine-effect {
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
          background-size: 200% 100%;
          animation: shine 2s infinite;
        }
        
        .float-animation {
          animation: float 3s ease-in-out infinite;
        }
        
        .glow-card {
          transition: all 0.3s ease;
        }
        
        .glow-card:hover {
          box-shadow: 0 0 20px rgba(59, 130, 246, 0.2), 0 0 40px rgba(59, 130, 246, 0.1);
          transform: translateY(-2px);
        }
        
        .glow-button {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }
        
        .glow-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
          transition: left 0.5s ease;
        }
        
        .glow-button:hover::before {
          left: 100%;
        }
        
        .glow-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(59, 130, 246, 0.4);
        }
        
        .glow-input {
          transition: all 0.3s ease;
        }
        
        .glow-input:focus {
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2), 0 0 0 5px rgba(59, 130, 246, 0.1);
          transform: scale(1.02);
        }
        
        .text-glow-blue {
          text-shadow: 0 0 10px rgba(59, 130, 246, 0.5), 0 0 20px rgba(59, 130, 246, 0.3);
        }
        
        .pulse-glow {
          animation: pulse-glow 2s infinite;
        }
        
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        
        .animation-delay-500 {
          animation-delay: 0.5s;
        }
      `}</style>
    </div>
  );
};

export default TradeCopier;